import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2e9e47c8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ui site menu" }
const _hoisted_2 = { class: "logo" }
const _hoisted_3 = { class: "title" }




export default /*#__PURE__*/_defineComponent({
  __name: 'SiteMenu',
  props: {
    title: {
        type: String,
        required: true
    }
},
  setup(__props) {

const props = __props

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_HeroHeader = _resolveComponent("HeroHeader")!

  return (_openBlock(), _createBlock(_component_HeroHeader, {
    zoom: 1.2,
    src: "https://images.unsplash.com/photo-1611716524065-622312678d68?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=3811&q=80"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_router_link, {
            to: "/",
            class: "image"
          })
        ]),
        _createElementVNode("div", _hoisted_3, _toDisplayString(props.title), 1)
      ])
    ]),
    _: 1
  }))
}
}

})